<template>
  <main class="w-full max-w-none">
    <div class="mx-auto w-full max-w-full px-0">
      <div class="mb-8">
        <h1 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2">流水查询</h1>
        <p class="text-gray-600">查询指定日期范围内的银行流水信息</p>
      </div>

      <div class="grid grid-cols-1 lg:grid-cols-5 gap-3 w-full">
        <!-- 左侧内容 -->
        <div class="w-full lg:col-span-3">
          <Card class="mb-8">
            <CardHeader>
              <CardTitle>接口说明</CardTitle>
              <CardDescription>
                流水查询接口用于获取指定日期范围内的银行流水信息。
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div
                class="flex items-center gap-4 mb-6 p-4 bg-gray-50 rounded-lg"
              >
                <span
                  class="px-3 py-1 bg-green-100 text-green-800 text-sm font-medium rounded-full"
                  >POST</span
                >
                <code class="text-sm font-mono">/api/v2/bs/list</code>
              </div>

              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求头参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-id
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            APP ID
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            4d9414e89bc24b0d89b678d9f20bc56a
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-app-secret
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            API Key
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            8201e508ef948b8fcdca855729e7ee34
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            x-customer-code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            客户编号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            CUSTFA48DD8EFF437956
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            Content-Type
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            发送内容类型
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            application/json
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    请求参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            必需
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            示例值
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            accountNo
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            银行账号
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            457258891947
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            dayFromId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            流水记账日期开始日
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            20240726
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            dayToId
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            流水记账日期结束日
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            20250725
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            pageNow
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            当前页码
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">1</td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            pageSize
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            是
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            每页记录数
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">20</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <h3 class="text-lg font-medium text-gray-900 mb-3">
                    响应参数
                  </h3>
                  <div class="overflow-x-auto">
                    <table class="min-w-max md:min-w-full divide-y divide-gray-200">
                      <thead class="bg-gray-50">
                        <tr>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            参数名
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            类型
                          </th>
                          <th
                            class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            描述
                          </th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            code
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回状态 200成功
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.searchBankStatementList
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Array
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回的流水列表
                          </td>
                        </tr>
                        <!-- 子表格：searchBankStatementList 每项的字段说明 -->
                        <tr>
                          <td colspan="3" class="px-3 md:px-6 py-4">
                            <div class="ml-6">
                              <table
                                class="min-w-max md:min-w-full divide-y divide-gray-200"
                              >
                                <thead class="bg-gray-50">
                                  <tr>
                                    <th
                                      class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      字段名
                                    </th>
                                    <th
                                      class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      类型
                                    </th>
                                    <th
                                      class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      描述
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  class="bg-white divide-y divide-gray-200"
                                >
                                  <tr>
                                    <td class="px-6 py-2 text-sm">accountNo</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      本方账号
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      accountName
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      本方账号名称
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">bank</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      本方银行
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      customerAccountNo
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      交易对手方账号
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      customerName
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      交易对手方账户名称
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      customerBank
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      交易对手方银行
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      accountingDateId
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      记账日期
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">transDate</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      交易日期
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">transFlag</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      R收入,P支出
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">crAmount</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      收入金额
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">drAmount</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      支出金额
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      balanceAmount
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      交易后余额
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">currency</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      币种
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">cashType</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      交易类型
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      bankTrxNumber
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      银行交易流水号
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      businessTransNo
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      外部交易流水号（付款单）
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      uniqueNumber
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      流水唯一识别号
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">userMemo</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      银行摘要/用途/附言
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">metaJson</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      扩展字段
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      createdTime
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      创建日期
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      updatedTime
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      String
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      更新日期
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            data.pageable
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Object
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            分页信息
                          </td>
                        </tr>
                        <!-- 子表格：pageable 对象字段说明 -->
                        <tr>
                          <td colspan="3" class="px-3 md:px-6 py-4">
                            <div class="ml-6">
                              <table
                                class="min-w-max md:min-w-full divide-y divide-gray-200"
                              >
                                <thead class="bg-gray-50">
                                  <tr>
                                    <th
                                      class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      字段名
                                    </th>
                                    <th
                                      class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      类型
                                    </th>
                                    <th
                                      class="px-3 md:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                      描述
                                    </th>
                                  </tr>
                                </thead>
                                <tbody
                                  class="bg-white divide-y divide-gray-200"
                                >
                                  <tr>
                                    <td class="px-6 py-2 text-sm">hasNext</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Boolean
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      是否有下一页
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">hasPre</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Boolean
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      是否有前一页
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">isFirst</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Boolean
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      是否是首页
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">isLast</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Boolean
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      是否是最后一页
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">pageNow</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Number
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      当前页
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">pageSize</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Number
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      页码
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">startPos</td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Number
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      开始位置，从0开始
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      totalCount
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Number
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      流水数量
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="px-6 py-2 text-sm">
                                      totalPageCount
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      Number
                                    </td>
                                    <td class="px-6 py-2 text-sm text-gray-500">
                                      总页数
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            message
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            失败时返回错误信息
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            realJsonModel
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            返回json，true
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            status
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            String
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            http状态码
                          </td>
                        </tr>
                        <tr>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >
                            successResponse
                          </td>
                          <td
                            class="px-3 md:px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                          >
                            Boolean
                          </td>
                          <td class="px-3 md:px-6 py-4 text-sm text-gray-500">
                            成功返回
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <!-- 右侧"试一试"区域 -->
        <div class="w-full lg:col-span-2">
          <Card>
            <CardHeader>
              <CardTitle>试一试</CardTitle>
              <CardDescription>使用不同语言测试API</CardDescription>
            </CardHeader>
            <CardContent>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8 overflow-x-auto">
                  <button
                    v-for="language in languages"
                    :key="language.id"
                    @click="activeLanguage = language.id"
                    class="whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm"
                    :class="[
                      activeLanguage === language.id
                        ? 'border-[var(--primary)] text-[var(--primary)]'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    ]"
                  >
                    {{ language.name }}
                  </button>
                </nav>
              </div>

              <div class="mt-6">
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ getRequestText() }}</code></pre>
                <div class="space-y-4">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-id</label
                    >
                    <input
                      v-model="appId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-app-secret</label
                    >
                    <input
                      v-model="authorization"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >x-customer-code</label
                    >
                    <input
                      v-model="customerCode"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >accountNo</label
                    >
                    <input
                      v-model="accountNo"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >dayFromId</label
                    >
                    <input
                      v-model="dayFromId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >dayToId</label
                    >
                    <input
                      v-model="dayToId"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >pageNow</label
                    >
                    <input
                      v-model="pageNow"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1"
                      >pageSize</label
                    >
                    <input
                      v-model="pageSize"
                      type="text"
                      class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[var(--primary)] focus:border-[var(--primary)]"
                    />
                  </div>
                  <button
                    @click="queryTransactions"
                    :disabled="loading"
                    class="w-full bg-[var(--primary)] hover:bg-[color:var(--primary)] text-white font-medium py-2 px-4 rounded-md transition duration-200 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ loading ? "查询中..." : "查询流水" }}
                  </button>
                </div>
              </div>

              <!-- 响应结果 -->
              <div v-if="response" class="mt-6">
                <h3 class="text-lg font-medium text-gray-900 mb-2">响应结果</h3>
                <pre
                  class="bg-gray-800 text-gray-100 p-4 rounded-md text-sm overflow-x-auto"
                ><code>{{ response }}</code></pre>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, onMounted, watch, nextTick } from "vue";
import Sidebar from "./Sidebar.vue";
import Card from "./ui/Card.vue";
import CardHeader from "./ui/CardHeader.vue";
import CardTitle from "./ui/CardTitle.vue";
import CardDescription from "./ui/CardDescription.vue";
import CardContent from "./ui/CardContent.vue";
import { useCodeHighlight } from "@/composables/useCodeHighlight";
import httpService from "@/lib/http";
import hljs from "highlight.js/lib/core";
import { getBaseDomain } from "@/lib/config";
// 使用代码高亮
const highlightCode = () => {
  nextTick(() => {
    // 等待DOM更新完成后再处理
    setTimeout(() => {
      // 找到所有代码块
      const allCodeBlocks = document.querySelectorAll("pre code");

      // 语言映射表
      const languageMap: { [key: string]: string } = {
        curl: "language-bash",
        javascript: "language-javascript",
        python: "language-python",
        java: "language-java",
        csharp: "language-csharp",
        php: "language-php",
        ruby: "language-ruby",
      };

      const langClass = languageMap[activeLanguage.value];

      // 处理所有代码块
      allCodeBlocks.forEach((block) => {
        // 清除之前的高亮
        block.className = "";
        block.removeAttribute("data-highlighted");

        // 重新添加基础类和语言类
        block.classList.add("hljs");
        if (langClass) {
          block.classList.add(langClass);
        }

        try {
          hljs.highlightElement(block as HTMLElement);
        } catch (error) {
          console.warn("代码高亮失败:", error);
        }
      });
    }, 100); // 减少延迟时间
  });
};

// 初始化代码高亮
highlightCode();

// 默认值
const DEFAULT_APP_ID = "登录后自动获取";
const DEFAULT_APP_SECRET = "登录后自动获取";
const DEFAULT_CUSTOMER_CODE = "登录后自动获取";

const appId = ref(DEFAULT_APP_ID);
const authorization = ref(DEFAULT_APP_SECRET);
const customerCode = ref(DEFAULT_CUSTOMER_CODE);
const dayFromId = ref("20240726");
const dayToId = ref("20250725");
const accountNo = ref("457258891947");
const pageNow = ref("1");
const pageSize = ref("20");
const loading = ref(false);
const response = ref("");
const activeLanguage = ref("curl");

// 获取应用信息
const getApplicationInfo = async () => {
  try {
    const response = await httpService.get<any>("/nxb/console/application/get");

    if (response) {
      return {
        appId: response.appId,
        appSecret: response.appSecret,
      };
    }
    return null;
  } catch (error) {
    console.log("获取应用信息失败:", error);
    return null;
  }
};

// 获取客户信息
const getCustomerInfo = async () => {
  try {
    const response = await httpService.get<any>(
      "/nxb/console/customer/listWithSummary",
      {
        pageNow: 1,
        pageSize: 10,
      }
    );

    if (response) {
      return response.customers[0].customerCode;
    }
    return null;
  } catch (error) {
    console.log("获取客户信息失败:", error);
    return null;
  }
};

// 登录后自动获取用户信息
const autoFetchUserInfo = async () => {
  const userInfoStr = localStorage.getItem("userInfo");

  if (userInfoStr) {
    // 获取应用信息
    const appInfo = await getApplicationInfo();

    if (appInfo) {
      appId.value = appInfo.appId;
      authorization.value = appInfo.appSecret;
    }

    // 获取客户信息
    const customerCodeValue = await getCustomerInfo();
    if (customerCodeValue) {
      customerCode.value = customerCodeValue;
    }
  }
};

// 组件挂载时登录后自动获取用户信息
onMounted(() => {
  autoFetchUserInfo();
});

// 监听响应式变量变化，重新应用代码高亮
watch(
  [appId, authorization, customerCode, activeLanguage, response],
  () => {
    highlightCode();
  },
  { flush: "post" }
);

// 语言选项
const languages = [
  { id: "curl", name: "cURL" },
  { id: "javascript", name: "JavaScript" },
  { id: "python", name: "Python" },
  { id: "java", name: "Java" },
  { id: "csharp", name: "C#" },
  { id: "php", name: "PHP" },
  { id: "ruby", name: "Ruby" },
];

// 获取请求文本
const getRequestText = () => {
  const headers = {
    "x-app-id": appId.value,
    "x-app-secret": authorization.value,
    "x-customer-code": customerCode.value,
  };

  const body = {
    accountNo: accountNo.value,
    dayFromId: dayFromId.value,
    dayToId: dayToId.value,
    pageNow: pageNow.value,
    pageSize: pageSize.value,
  };

  switch (activeLanguage.value) {
    case "curl":
      return (
        `curl -X POST '${getBaseDomain()}/api/v2/bs/list' \\\n` +
        `  -H 'x-app-id: ${appId.value}' \\\n` +
        `  -H 'x-app-secret: ${authorization.value}' \\\n` +
        `  -H 'x-customer-code: ${customerCode.value}' \\\n` +
        `  -H 'Content-Type: application/json' \\\n` +
        `  -d '{"accountNo":"${accountNo.value}","dayFromId":"${dayFromId.value}","dayToId":"${dayToId.value}","pageNow":"${pageNow.value}","pageSize":"${pageSize.value}"}'`
      );

    case "javascript":
      return (
        `const axios = require('axios');\n\n` +
        `const data = {\n` +
        `  'accountNo': '${accountNo.value}',\n` +
        `  'dayFromId': '${dayFromId.value}',\n` +
        `  'dayToId': '${dayToId.value}',\n` +
        `  'pageNow': '${pageNow.value}',\n` +
        `  'pageSize': '${pageSize.value}'\n` +
        `};\n\n` +
        `const config = {\n` +
        `  method: 'post',\n` +
        `  url: '${getBaseDomain()}/api/v2/bs/list',\n` +
        `  headers: { \n` +
        `    'x-app-id': '${appId.value}',\n` +
        `    'x-app-secret': '${authorization.value}',\n` +
        `    'x-customer-code': '${customerCode.value}',\n` +
        `    'Content-Type': 'application/json'\n` +
        `  },\n` +
        `  data: data\n` +
        `};\n\n` +
        `axios(config)\n` +
        `  .then(function (response) {\n` +
        `    console.log(JSON.stringify(response.data));\n` +
        `  })\n` +
        `  .catch(function (error) {\n` +
        `    console.log(error);\n` +
        `  });`
      );

    case "python":
      return (
        `import requests\n` +
        `import json\n\n` +
        `url = "${getBaseDomain()}/api/v2/bs/list"\n\n` +
        `payload = {\n` +
        `  "accountNo": "${accountNo.value}",\n` +
        `  "dayFromId": "${dayFromId.value}",\n` +
        `  "dayToId": "${dayToId.value}",\n` +
        `  "pageNow": "${pageNow.value}",\n` +
        `  "pageSize": "${pageSize.value}"\n` +
        `}\n` +
        `headers = {\n` +
        `  'x-app-id': '${appId.value}',\n` +
        `  'x-app-secret': '${authorization.value}',\n` +
        `  'x-customer-code': '${customerCode.value}',\n` +
        `  'Content-Type': 'application/json'\n` +
        `}\n\n` +
        `response = requests.request("POST", url, headers=headers, data=json.dumps(payload))\n\n` +
        `print(response.text)`
      );

    case "java":
      return (
        `OkHttpClient client = new OkHttpClient().newBuilder()\n` +
        `  .build();\n` +
        `MediaType mediaType = MediaType.parse("application/json");\n` +
        `String json = "{\\\"accountNo\\\":\\\"${accountNo.value}\\\",\\\"dayFromId\\\":\\\"${dayFromId.value}\\\",\\\"dayToId\\\":\\\"${dayToId.value}\\\",\\\"pageNow\\\":\\\"${pageNow.value}\\\",\\\"pageSize\\\":\\\"${pageSize.value}\\\"}";\n` +
        `RequestBody body = RequestBody.create(mediaType, json);\n` +
        `Request request = new Request.Builder()\n` +
        `  .url("${getBaseDomain()}/api/v2/bs/list")\n` +
        `  .method("POST", body)\n` +
        `  .addHeader("x-app-id", "${appId.value}")\n` +
        `  .addHeader("x-app-secret", "${authorization.value}")\n` +
        `  .addHeader("x-customer-code", "${customerCode.value}")\n` +
        `  .addHeader("Content-Type", "application/json")\n` +
        `  .build();\n` +
        `Response response = client.newCall(request).execute();`
      );

    case "csharp":
      return (
        `var client = new RestClient("${getBaseDomain()}/api/v2/bs/list");\n` +
        `var request = new RestRequest(Method.POST);\n` +
        `request.AddHeader("x-app-id", "${appId.value}");\n` +
        `request.AddHeader("x-app-secret", "${authorization.value}");\n` +
        `request.AddHeader("x-customer-code", "${customerCode.value}");\n` +
        `request.AddHeader("Content-Type", "application/json");\n` +
        `request.AddJsonBody(new { accountNo = "${accountNo.value}", dayFromId = "${dayFromId.value}", dayToId = "${dayToId.value}", pageNow = "${pageNow.value}", pageSize = "${pageSize.value}" });\n` +
        `IRestResponse response = client.Execute(request);\n` +
        `Console.WriteLine(response.Content);`
      );

    case "php":
      return (
        `<?php\n\n` +
        `$curl = curl_init();\n\n` +
        `curl_setopt_array($curl, array(\n` +
        `  CURLOPT_URL => '${getBaseDomain()}/api/v2/bs/list',\n` +
        `  CURLOPT_RETURNTRANSFER => true,\n` +
        `  CURLOPT_ENCODING => '',\n` +
        `  CURLOPT_MAXREDIRS => 10,\n` +
        `  CURLOPT_TIMEOUT => 0,\n` +
        `  CURLOPT_FOLLOWLOCATION => true,\n` +
        `  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,\n` +
        `  CURLOPT_CUSTOMREQUEST => 'POST',\n` +
        `  CURLOPT_POSTFIELDS => json_encode(array(\n` +
        `    'accountNo' => '${accountNo.value}',\n` +
        `    'dayFromId' => '${dayFromId.value}',\n` +
        `    'dayToId' => '${dayToId.value}',\n` +
        `    'pageNow' => '${pageNow.value}',\n` +
        `    'pageSize' => '${pageSize.value}'\n` +
        `  )),\n` +
        `  CURLOPT_HTTPHEADER => array(\n` +
        `    'x-app-id: ${appId.value}',\n` +
        `    'x-app-secret: ${authorization.value}',\n` +
        `    'x-customer-code: ${customerCode.value}',\n` +
        `    'Content-Type: application/json'\n` +
        `  ),\n` +
        `));\n\n` +
        `$response = curl_exec($curl);\n\n` +
        `curl_close($curl);\n` +
        `echo $response;`
      );

    case "ruby":
      return (
        `require "uri"\n` +
        `require "net/http"\n\n` +
        `url = URI("${getBaseDomain()}/api/v2/bs/list")\n\n` +
        `https = Net::HTTP.new(url.host, url.port);\n` +
        `https.use_ssl = true\n\n` +
        `request = Net::HTTP::Post.new(url)\n` +
        `request["x-app-id"] = "${appId.value}"\n` +
        `request["x-app-secret"] = "${authorization.value}"\n` +
        `request["x-customer-code"] = "${customerCode.value}"\n` +
        `request["Content-Type"] = "application/json"\n` +
        `request.body = "{\\\"accountNo\\\":\\\"${accountNo.value}\\\",\\\"dayFromId\\\":\\\"${dayFromId.value}\\\",\\\"dayToId\\\":\\\"${dayToId.value}\\\",\\\"pageNow\\\":\\\"${pageNow.value}\\\",\\\"pageSize\\\":\\\"${pageSize.value}\\\"}"\n\n` +
        `response = https.request(request)\n` +
        `puts response.read_body`
      );

    default:
      return "";
  }
};

// cURL方式查询流水
const queryTransactions = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/bs/list", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountNo: accountNo.value,
        dayFromId: dayFromId.value,
        dayToId: dayToId.value,
        pageNow: pageNow.value,
        pageSize: pageSize.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// JavaScript方式查询流水
const queryTransactionsJS = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const config = {
      method: "POST",
      url: "/api/v2/bs/list",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountNo: accountNo.value,
        dayFromId: dayFromId.value,
        dayToId: dayToId.value,
        pageNow: pageNow.value,
        pageSize: pageSize.value,
      }),
    };

    const res = await fetch(config.url, {
      method: config.method,
      headers: config.headers,
      body: config.body,
    });

    const responseData = await res.json();
    response.value = JSON.stringify(responseData, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Python方式查询流水 (模拟)
const queryTransactionsPython = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/bs/list", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountNo: accountNo.value,
        dayFromId: dayFromId.value,
        dayToId: dayToId.value,
        pageNow: pageNow.value,
        pageSize: pageSize.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Java方式查询流水
const queryTransactionsJava = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/bs/list", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountNo: accountNo.value,
        dayFromId: dayFromId.value,
        dayToId: dayToId.value,
        pageNow: pageNow.value,
        pageSize: pageSize.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// C#方式查询流水
const queryTransactionsCSharp = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/bs/list", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountNo: accountNo.value,
        dayFromId: dayFromId.value,
        dayToId: dayToId.value,
        pageNow: pageNow.value,
        pageSize: pageSize.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// PHP方式查询流水
const queryTransactionsPHP = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/bs/list", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountNo: accountNo.value,
        dayFromId: dayFromId.value,
        dayToId: dayToId.value,
        pageNow: pageNow.value,
        pageSize: pageSize.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};

// Ruby方式查询流水
const queryTransactionsRuby = async () => {
  if (!appId.value || !authorization.value || !customerCode.value) {
    alert("请填写所有必填字段");
    return;
  }

  loading.value = true;
  response.value = "";

  try {
    const res = await fetch("/api/v2/bs/list", {
      method: "POST",
      headers: {
        "x-app-id": appId.value,
        "x-app-secret": authorization.value,
        "x-customer-code": customerCode.value,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountNo: accountNo.value,
        dayFromId: dayFromId.value,
        dayToId: dayToId.value,
        pageNow: pageNow.value,
        pageSize: pageSize.value,
      }),
    });

    const data = await res.json();
    response.value = JSON.stringify(data, null, 2);
  } catch (error) {
    response.value = JSON.stringify(
      { error: "请求失败: " + (error as Error).message },
      null,
      2
    );
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
/* 添加任何需要的自定义样式 */
</style>
